module.exports = __webpack_public_path__ + "img/00016.b2ccd961.webp";